import { useState } from 'react';
import TopUsers from '../_shared/TopUsers/TopUsers'
import useTopEmployeesCompany from './useTopEmployeesCompany'
import TopUsersPopup from '../_shared/TopUsers/TopUsersPopup';

function TopEmployeesCompany({ col = 7, row = 8 }: { col?: number; row?: number } = {}) {

  const {
    loading,
    error,
    fullMessage,
    top,
    top5,
    current,
    currentUserId,

    planTypes,
    setIsPeriod, isPeriod,
    typeId, setTypeId
  } = useTopEmployeesCompany();

  const [open, setOpen] = useState(false)

  return (
    <>
      <TopUsers
        col={col}
        row={row}
        title='Топ сотрудников (компания)'
        loading={loading}
        fullMessage={fullMessage}
        error={error}
        top={top5}
        currentUserId={currentUserId}
        current={current}
        setOpenPopup={() => setOpen(true)}
      />
      <TopUsersPopup 
        open={open}
        onClose={() => setOpen(false)}
        title='Топ сотрудников (компания)'
        data={top}
        loading={loading}

        planTypes={planTypes}
        isPeriod={isPeriod}
        setIsPeriod={setIsPeriod}
        typeId={typeId}
        setTypeId={setTypeId}
      />
    </>
  )
}

export default TopEmployeesCompany
